import Vue from 'vue';
import VueRouter from 'vue-router';
import OnboardingFlow from '@/views/OnboardingFlow.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'OnboardingFlow',
    component: OnboardingFlow
  },
  {
    path: '/linkExpired',
    name: 'LinkExpired',
    component: () =>
      import(/* webpackChunkName: "linkExpired" */ '../views/LinkExpired.vue')
  },
  {
    path: '/unoptomized',
    name: 'unoptomized',
    component: () =>
      import(
        /* webpackChunkName: "mobileActivation" */ '../views/Unoptomized.vue'
      )
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () =>
      import(
        /* webpackChunkName: "mobileActivation" */ '../views/MobileActivation.vue'
      )
  }
];

const router = new VueRouter({
  routes
});

export default router;
